// Auth storage key used by Zustand persist
export const AUTH_STORAGE_KEY = 'auth-storage';

/**
 * Validate if the parsed JSON has the expected auth storage structure
 */
export function isValidAuthStorage(data: unknown): data is {
  state: { user?: unknown; isAuthenticated?: boolean; isInitialized?: boolean };
} {
  if (!data || typeof data !== 'object') return false;
  const obj = data as Record<string, unknown>;
  if (!obj.state || typeof obj.state !== 'object') return false;
  const state = obj.state as Record<string, unknown>;
  return typeof state.isAuthenticated === 'boolean';
}

/**
 * Check if user is authenticated via persisted state.
 * Note: This is a synchronous check for router beforeLoad.
 * Tokens are stored in HttpOnly cookies, so we check for user and isAuthenticated flag.
 */
export function isAuthenticated(): boolean {
  const authStorage = localStorage.getItem(AUTH_STORAGE_KEY);
  if (!authStorage) return false;

  try {
    const parsed: unknown = JSON.parse(authStorage);
    if (!isValidAuthStorage(parsed)) {
      // Invalid structure, clear corrupted data
      localStorage.removeItem(AUTH_STORAGE_KEY);
      return false;
    }
    return !!parsed.state.user && parsed.state.isAuthenticated === true;
  } catch {
    // JSON parse error, clear corrupted data
    localStorage.removeItem(AUTH_STORAGE_KEY);
    return false;
  }
}
